import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import { DiscountConfigurationPage, DistributorPage } from '../lazyPages';

export const DistributorRoutes = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.DISTRIBUTOR.TITLE')}>
            <DistributorPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="discount-configuration"
        element={
          <GuardedPageRoute
            pageName={t('STAFF_SIDEBAR.DISTRIBUTOR.DISCOUNT_CONFIGURATION')}
            fallbackPath="/distributor"
          >
            <DiscountConfigurationPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
